// extracted by mini-css-extract-plugin
export var section = "styles-module--section--1AZjo";
export var title = "styles-module--title--268HE";
export var videoWrap = "styles-module--videoWrap--3Ssnm";
export var illustration = "styles-module--illustration--3jOzB";
export var video = "styles-module--video--321aS";